<template>
  <div class="app-overlay">
    <spinner
      line-fg-color="#313942"
      line-bg-color="#eee"
      message="Loading application.."
      :spacing="10"
    ></spinner>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";

export default {
  name: "AppOverlay",

  components: {
    Spinner
  }
};
</script>

<style scoped>
@import "../assets/styles/_variables.scss";

.app-overlay {
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  z-index: 100;
}
</style>
